import React from 'react';
export const ChristmasDecorations = () => {
  return <>
      {/* Snowflakes - Reduced from 30 to 10 for a more subtle effect */}
      <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden" data-id="element-99">
        {[...Array(10)].map((_, i) => <div key={i} className="absolute text-white opacity-50 animate-snowfall" style={{
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 10}s`,
        animationDuration: `${15 + Math.random() * 10}s`,
        fontSize: `${10 + Math.random() * 10}px`
      }} data-id="element-100">
            ❄
          </div>)}
      </div>

      {/* Garlands (Guirnaldas) - Festive swags at the top */}
      <div className="fixed top-0 left-0 right-0 h-20 pointer-events-none z-30 flex overflow-hidden" data-id="element-101">
        {/* Create enough swags to cover the width. Using flex-1 to distribute them evenly. */}
        {[...Array(12)].map((_, i) => <div key={i} className="relative flex-1 h-full min-w-[60px] max-w-[150px]" data-id="element-102">
            {/* Green Garland Swag */}
            <svg viewBox="0 0 100 45" className="w-full h-full drop-shadow-md" preserveAspectRatio="none" data-id="element-103">
              {/* Main thick green garland */}
              <path d="M-2,0 Q50,45 102,0" fill="none" stroke="#165B33" strokeWidth="8" strokeLinecap="round" data-id="element-104" />
              {/* Lighter green detail for texture */}
              <path d="M-2,0 Q50,45 102,0" fill="none" stroke="#2E8B57" strokeWidth="2" strokeDasharray="5 5" className="opacity-60" data-id="element-105" />
            </svg>

            {/* Red Bow at the connection point */}
            <div className="absolute top-0 -left-3 w-6 h-6 z-10 flex justify-center items-center" data-id="element-106">
              {/* Center knot */}
              <div className="w-2.5 h-2.5 bg-red-600 rounded-full z-20 shadow-sm relative" data-id="element-107"></div>
              {/* Left loop */}
              <div className="absolute top-1 left-0 w-3 h-3 bg-red-600 rounded-full z-10 transform -rotate-12" data-id="element-108"></div>
              {/* Right loop */}
              <div className="absolute top-1 right-0 w-3 h-3 bg-red-600 rounded-full z-10 transform rotate-12" data-id="element-109"></div>
              {/* Ribbons hanging down */}
              <div className="absolute top-2 left-1 w-1.5 h-4 bg-red-600 transform rotate-12 rounded-b-sm" data-id="element-110"></div>
              <div className="absolute top-2 right-1 w-1.5 h-4 bg-red-600 transform -rotate-12 rounded-b-sm" data-id="element-111"></div>
            </div>
          </div>)}
        {/* Final bow for the right edge */}
        <div className="absolute top-0 right-0 w-6 h-6 z-10 translate-x-3" data-id="element-112">
          <div className="w-full h-full relative flex justify-center items-center" data-id="element-113">
            <div className="w-2.5 h-2.5 bg-red-600 rounded-full z-20 shadow-sm" data-id="element-114"></div>
            <div className="absolute top-1 left-0 w-3 h-3 bg-red-600 rounded-full z-10 transform -rotate-12" data-id="element-115"></div>
            <div className="absolute top-1 right-0 w-3 h-3 bg-red-600 rounded-full z-10 transform rotate-12" data-id="element-116"></div>
            <div className="absolute top-2 left-1 w-1.5 h-4 bg-red-600 transform rotate-12 rounded-b-sm" data-id="element-117"></div>
            <div className="absolute top-2 right-1 w-1.5 h-4 bg-red-600 transform -rotate-12 rounded-b-sm" data-id="element-118"></div>
          </div>
        </div>
      </div>

      {/* Christmas Lights Border - Top */}
      <div className="fixed top-1 left-0 right-0 h-8 pointer-events-none z-40 flex justify-around items-center" data-id="element-119">
        {[...Array(20)].map((_, i) => <div key={i} className="w-3 h-3 rounded-full animate-twinkle" style={{
        backgroundColor: ['#C41E3A', '#165B33', '#FFD700', '#00C3FF'][i % 4],
        animationDelay: `${i * 0.2}s`,
        boxShadow: `0 0 10px ${['#C41E3A', '#165B33', '#FFD700', '#00C3FF'][i % 4]}`
      }} data-id="element-120" />)}
      </div>

      {/* Hanging Ornaments */}
      <div className="fixed top-8 left-0 right-0 pointer-events-none z-40 flex justify-around" data-id="element-121">
        {[...Array(8)].map((_, i) => <div key={i} className="flex flex-col items-center animate-float" style={{
        animationDelay: `${i * 0.3}s`
      }} data-id="element-122">
            <div className="w-0.5 h-4 bg-christmas-silver opacity-50" data-id="element-123" />
            <div className="w-6 h-6 rounded-full shadow-christmas-glow" style={{
          backgroundColor: ['#C41E3A', '#165B33', '#FFD700'][i % 3],
          boxShadow: `0 0 15px ${['#C41E3A', '#165B33', '#FFD700'][i % 3]}`
        }} data-id="element-124" />
          </div>)}
      </div>
    </>;
};